import script from "./writeOff.vue?vue&type=script&setup=true&lang=js"
export * from "./writeOff.vue?vue&type=script&setup=true&lang=js"

import "./writeOff.vue?vue&type=style&index=0&id=6469bfd9&lang=scss"

const __exports__ = script;

export default __exports__